module.exports = "/_next/static/images/ActImage@2x-ce259f3d2a3ad02b465403b570778ebd.webp";